import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M23.5721 20.7962C22.8361 23.0512 19.9241 24.1708 17.8601 23.9789C15.0281 23.723 11.9401 22.2196 9.60412 20.5723C6.16412 18.1413 2.94812 14.3828 1.06012 10.3845C-0.267884 7.56961 -0.555882 4.09903 1.41212 1.52409C2.14812 0.580475 2.93212 0.0686902 4.11612 0.00471656C5.76412 -0.0752506 5.98812 0.868357 6.54812 2.32376C6.96412 3.41131 7.52412 4.53084 7.84412 5.66638C8.43612 7.7935 6.37212 7.87348 6.11612 9.60077C5.95612 10.6883 7.28411 12.1597 7.87611 12.9434C9.04411 14.4628 10.4521 15.7902 12.0521 16.7818C12.9641 17.3576 14.4361 18.3972 15.4761 17.8214C17.0761 16.9418 16.9321 14.2389 19.1721 15.1505C20.3401 15.6303 21.4601 16.302 22.5801 16.9098C24.3081 17.8534 24.2281 18.797 23.5721 20.7962C23.0761 22.2676 24.0681 19.3088 23.5721 20.7962Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
